import SelectComponent from '../forms/select';

const selects = Array.from(document.querySelectorAll('.umbraco-forms-field.dropdown'));

// Convert each of the dropdowns within the Umbraco Forms form into a custom dropdown.
selects.forEach(x => {
    const wrapperEl = x.querySelector('.umbraco-forms-field-wrapper');
    const selectEl = x.querySelector('select');
    const options = Array.from(selectEl.querySelectorAll('option'))
        .map(y => {
            return {
                label: y.innerText,
                value: y.value,
            };
        })
        .filter(y => y.label.length);
    const select = new SelectComponent({
        placeholder: x.querySelector('label').innerText,
        id: selectEl.id,
        options: options,
        showOptionLabels: true,
        mirrorValueToOriginal: selectEl,
    });
    wrapperEl.appendChild(select.el);
    selectEl.tabIndex = -1;
});
